import { gql } from '@apollo/client';

const MIGRATE_AI_DATA_VER1_TO_VER2_MUTATION = gql`
  mutation migrateAiDataVer1ToVer2($input: MigrateAiDataInput!) {
    migrateAiDataVer1ToVer2(input: $input) {
      isSuccess
      message
    }
  }
`;

export default MIGRATE_AI_DATA_VER1_TO_VER2_MUTATION;
